import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getDocumentById } from '../actions/prismic';
import { getDocById } from '../selectors/entities';
import { getDocByIdError } from '../selectors/errors';
import { getDocByIdLoader } from '../selectors/loaders';

/* TODO : create types for data, error and loading as well as the result object */
const useDocumentById = <T>(
  documentType: string,
  documentId: string
): { data: T; error: any; loading: any } => {
  const dispatch = useDispatch();
  const data: T = useSelector(getDocById(documentType, documentId));
  const error = useSelector(getDocByIdError(documentId));
  const loading = useSelector(getDocByIdLoader(documentId));

  useEffect(() => {
    if (documentType && !loading && !error && !data) {
      dispatch(getDocumentById(documentId));
    }
  }, [dispatch, data, loading, error, documentType, documentId]);

  return { data, error, loading };
};

export default useDocumentById;
